import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    button: {
      margin: theme.spacing(1),
      // float: 'right',
      paddingBottom: 1,
      backgroundColor:'#8da5ed',
    },
    root: {
      "& .MuiFormControl-root": {
        margin: "5px 0",
      },
      "& .MuiSelect-root": {
        backgroundColor: "white",
        borderRadius: "3px",
        height: "15px",
      },
      "& .MuiFilledInput-underline:before": {
        borderBottom: "none",
      },
      "& .MuiFilledInput-underline:after": {
        borderBottom: "none",
      },
      "& .MuiPaper-root": {
      backgroundColor:'#f4f4f4',
    },   
      borderRadius: 4,
    },
    underline: {
      "&&&:before": {
        borderBottom: "none",
      },
      "&&:after": {
        borderBottom: "none",
      },
    },
      
    paper: {
      // padding: theme.spacing(2),
      // width: '100%',   
      
      height: '100vh',
      // background color for all pages with tables

      backgroundColor:'#f4f4f4',
      
     
    },
    formControl: {
      width: "100%",
    },
    papertabs:{
      background: 'linear-gradient(to bottom, #8da5ed,#d1dbf8 )',
      // "&. makeStyles-papertabs-7":{
      //   backgroundColor: 'red'
      // },
      color: 'blue',
      // position: 'fixed',
     
      // marginTop: '22px',
      // marginBottom: '0px',
      // width: '20%',
      width:'80px',
      float: 'left',
      height: '100vh'

    },

    tabs:{
      "& .MuiTab-root": {
        minWidth: '65px'
      },
     
    
    },
   
    tabpanel:{
      // marginTop: '87px',
      // position: 'fixed',
      // width: '100%',
      height: '100vh',
      // backgroundColor: '#96c8d8',
      // backgroundColor:'#FAFAFA',

    },

    iconbutton:{
      // padding: "10px",
      // float: 'right',
      position:'absolute',
      right: 0,
      top: 30,
      // paddingBottom: '35px',
      // verticalAlign: 'baseline'
      // margin: theme.spacing(1),
    
    },

    
    donutpaper:{
      // width: '100%', 
      backgroundColor: '#f4f4f4',
      height: '100vh',
     
    },
    input: {
      backgroundColor: "white",
      borderRadius: "3px",
      height: "15px",
    },
    
  }));



  